import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#facc15',
        },
        secondary: {
            main: '#9c27b0',
        },
        background: {
            default: '#f4f4f4',
        },
        text: {
            primary: '#333',
        },
    },
    typography: {
        fontFamily: 'Inter, sans-serif',
        h1: {
            fontWeight: 'bold',
            fontSize: '3rem',
        },
        body1: {
            fontSize: '1rem',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    textTransform: 'capitalize',
                    fontWeight: '500',
                    padding: '0.3rem 1rem',
                    '&.Mui-disabled': {
                        color: '#ffffff3d',
                        background: '#1b1b1b'
                    }
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    '&:hover': {
                        backgroundColor: '#303030',
                    },
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    backgroundColor: '#121212',
                    borderRadius: '12px',
                    border: '1px solid #ffffff0c',
                    overflow: 'hidden',
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    backgroundColor: '#121212',
                    borderCollapse: 'separate',
                    borderSpacing: 0,
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0f0f0f',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    transition: 'background-color 0.15s ease',

                    '&:hover': {
                        backgroundColor: '#1b1b1b',
                    },

                    '&.Mui-selected': {
                        backgroundColor: '#1f1f1f',

                        '&:hover': {
                            backgroundColor: '#262626',
                        },
                    },
                },
            },
        },

        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '0.8rem',
                    borderBottom: '1px solid #ffffff0c !important',
                },
                head: {
                    color: '#6b7280',
                    fontWeight: '400',
                    fontSize: '12px',
                },
                body: {
                    color: '#d1d5db',
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: '#e5e7eb',
                    borderTop: '1px solid #ffffff0c',
                    backgroundColor: '#121212',
                },

                toolbar: {
                    minHeight: '48px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                },

                selectLabel: {
                    marginBottom: 0,
                    color: '#9ca3af',
                    fontSize: '0.8rem',
                },

                displayedRows: {
                    marginBottom: 0,
                    color: '#9ca3af',
                    fontSize: '0.8rem',
                },

                select: {
                    color: '#f3f4f6',
                    backgroundColor: '#1b1b1b',
                    borderRadius: '6px',
                    padding: '4px 28px 4px 10px',

                    '&:focus': {
                        backgroundColor: '#1b1b1b',
                    },
                },

                menuItem: {
                    fontSize: '0.85rem',
                },

                actions: {
                    '& .MuiButtonBase-root': {
                        color: '#e5e7eb',
                        borderRadius: '6px',
                        marginLeft: '4px',

                        '&:hover': {
                            backgroundColor: '#1b1b1b',
                        },

                        '&.Mui-disabled': {
                            color: '#ffffff3d',
                        },
                    },
                },
            },
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    padding: '24px',
                    backgroundColor: '#121212',
                    color: '#f3f4f6'
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontFamily: 'Inter !important',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    padding: '0.5rem',
                    color: '#fff'
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingTop: 8,
                },
            },
        },

        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
            },
            styleOverrides: {
                root: {
                    borderRadius: '4px'
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: '#1b1b1b',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ffffff0c',
                        borderWidth: 2,
                    },
                    padding: 0
                },
                input: {
                    padding: '0.6rem 0.75rem',
                    color: '#fff',
                    '&.Mui-disabled': {
                        WebkitTextFillColor: '#ffffff3d',
                    },
                },
                notchedOutline: {
                    borderColor: '#1b1b1b',
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                root: {},
                paper: {
                    background: '#1b1b1b'
                },
                list: {
                    background: '#1b1b1b'
                }
            },
        },
        MuiMenuItem: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    color: '#fff',
                    '&:hover': {
                        backgroundColor: '#121212',
                        color: '#fff',
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#483F1A',
                        color: '#facc15',
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#483F1A',
                        color: '#facc15',
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    background: '#36393b'
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: '#ffffffb3',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                icon: {
                    color: '#fff',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: '#9ca3af',
                    lineHeight: 1,
                    minHeight: '30px',
                    borderRadius: '6px',
                    textTransform: 'Capitalize',
                    fontSize: '1rem',
                    padding: '10px 15px',
                    fontWeight: '400',

                    '&:hover': {
                        color: '#facc15',
                    },
                    '&.Mui-selected': {
                        background: '#facc15',
                        color: '#030712',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: '36px'
                },
                indicator: {
                    display: 'none',
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#ffffffb3',
                    '&.Mui-disabled': {
                        color: '#ffffff3d'
                    }
                }
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    marginRight: '15px',
                }
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: '#ffffffb3',
                    '.Mui-disabled &': {
                        color: '#ffffff3d',
                    },
                }
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#121212',
                    borderRadius: '12px',
                    border: '1px solid #ffffff0c',
                    boxShadow: 'none',
                    transition: 'border-color 0.2s ease, transform 0.2s ease',

                    '&:hover': {
                        borderColor: 'none',
                    },
                },
            },
        },

        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: '16px 20px 0',
                },
                title: {
                    color: '#f3f4f6',
                    fontWeight: 600,
                    fontSize: '1rem',
                },
                subheader: {
                    color: '#9ca3af',
                    fontSize: '0.85rem',
                },
            },
        },

        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '16px 20px',
                    color: '#d1d5db',
                    '&:last-child': {
                        paddingBottom: '20px',
                    },
                },
            },
        },

        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '12px 20px 16px',
                    borderTop: '1px solid #ffffff0c',
                },
            },
        },

        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    backgroundColor: '#121212',
                    border: '1px solid #ffffff0c',
                    borderRadius: '10px',
                    padding: '4px',
                },
                grouped: {
                    margin: '0 2px',
                    border: 'none',
                    borderRadius: '8px !important',
                },
            },
        },

        MuiToggleButton: {
            styleOverrides: {
                root: {
                    color: '#9ca3af',
                    textTransform: 'capitalize',
                    fontSize: '0.9rem',
                    fontWeight: 500,
                    padding: '6px 14px',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',

                    '&:hover': {
                        backgroundColor: '#1b1b1b',
                        color: '#facc15',
                    },

                    '&.Mui-selected': {
                        backgroundColor: '#facc15',
                        color: '#030712',
                        fontWeight: 600,

                        '&:hover': {
                            backgroundColor: '#facc15',
                        },
                    },

                    '&.Mui-disabled': {
                        color: '#ffffff3d',
                    },
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: '#ffffff0c',
                    opacity: 1,
                },
                light: {
                    borderColor: '#ffffff08',
                },
                vertical: {
                    borderColor: '#ffffff0c',
                },
            },
        },

    },
});

export default theme;